"use client";

import { IconClear, IconSearch } from "@/components";
import React from "react";

interface SearchInputProps {
    value?: string;
    onChange: (value: string) => void;
    onSearch?: () => void;
    onClear?: () => void;
    placeholder?: string;
    className?: string;
}

const Search: React.FC<SearchInputProps> = ({
    value = "",
    onChange,
    onSearch,
    onClear,
    placeholder = "Search",
    className = "",
}) => {
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            e.preventDefault();
            onSearch?.();
        }
    };

    const handleSearch = () => {
        onSearch?.();
    };

    const handleClear = () => {
        onChange("");
        onClear?.();
    };

    return (
        <div className={`relative w-full ${className}`}>
            <button
                type="button"
                onClick={handleSearch}
                className="absolute left-3 top-1/2 -translate-y-1/2 text-grey hover:text-black cursor-pointer bg-transparent border-none p-0 m-0"
                aria-label="Search"
            >
                <IconSearch width={24} height={24} />
            </button>
            <input
                type="text"
                value={value}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                placeholder={placeholder}
                className="w-full h-9 pl-10 pr-10 border border-black focus:border-light-grey font-raleway text-sm text-black outline-none bg-white tracking-[0.1em] placeholder-black"
            />
            {value && (
                <button
                    type="button"
                    onClick={handleClear}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-grey hover:text-black p-0 m-0 bg-transparent border-none cursor-pointer"
                    aria-label="Clear search"
                    tabIndex={0}
                >
                    <IconClear width={10} height={10} />
                </button>
            )}
        </div>
    );
};

export default Search; 